import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useInfiniteQueryMemberInvoiceListNewAsMember } from "@gymflow/api";
import { usePortalRoutes } from "apps/portal/src/hooks";
import { RouteFeature } from "apps/portal/src/routes";
import { useTranslation } from "react-i18next";

import useGymflowModels from "../../../store";
import { Spinner } from "../../atoms";
import { EmptyPage } from "../../atoms/EmptyPage";
import { HostedPagesBackHeader } from "../components/HostedPagesBackHeader";
import useRedirectIfNotAuthenticated from "../useRedirectIfNotAuthenticated";
import { HostedPagesHighlightedInvoice } from "./components/HostedPagesHighlightedInvoice";
import { HostedPagesProfileReceiptsList } from "./components/HostedPagesProfileReceiptsList";

export const HostedPagesReceipts = () => {
  const { t } = useTranslation();
  const { createSiteOrEmbedLink } = usePortalRoutes();
  useRedirectIfNotAuthenticated(
    createSiteOrEmbedLink(
      RouteFeature.SiteBuyMembershipType.replace(":membershipType", "all"),
    ),
  );
  const { api } = useGymflowModels();
  const { data: invoiceList, isLoading } =
    useInfiniteQueryMemberInvoiceListNewAsMember({
      api,
      params: {
        limit: 15,
      },
    });
  const [parent] = useAutoAnimate();
  const [parent2] = useAutoAnimate();
  return (
    <div className="track-height flex size-full flex-col">
      <HostedPagesBackHeader
        label={t("page.hostedPagesProfileReceipts.header")}
      />
      <div
        ref={parent}
        className="track-height flex h-full max-h-full flex-col justify-center  gap-3 bg-gray-50 p-4 lg:flex-row lg:gap-4 lg:p-6 lg:px-28 dark:bg-gray-800"
      >
        {isLoading && <Spinner />}
        {!isLoading && invoiceList?.pages[0].content.length === 0 && (
          <EmptyPage
            textOverride={t("pages.hostedPagesProfileReceipts.emptyPage.title")}
            description={t(
              "pages.hostedPagesProfileReceipts.emptyPage.description",
            )}
          />
        )}
        {!isLoading &&
          invoiceList?.pages[0].content &&
          invoiceList?.pages[0].content.length > 0 && (
            <>
              <div ref={parent2} className="flex flex-col gap-2 lg:flex-1">
                <HostedPagesHighlightedInvoice />
              </div>
              <HostedPagesProfileReceiptsList />
            </>
          )}
      </div>
    </div>
  );
};
